/**
 * WorkshopRegistrationConstants
 * Field names and domain constants for Workshop Registration.
 */
export class WorkshopRegistrationConstants {
    static FULL_NAME = 'FullName';
    static EMAIL = 'Email';
    static IDENTITY_DOCUMENT = 'IdentityDocument';
}

export default WorkshopRegistrationConstants;
